import axios from "axios";

let authRedirecting = false;

function clearExpiredToken() {
  const expires = "Thu, 01 Jan 1970 00:00:00 GMT";
  document.cookie = `mtoken=; expires=${expires}; path=/`;

  const hostname = window.location.hostname;
  if (hostname.endsWith(".panzitech.com")) {
    document.cookie = `mtoken=; expires=${expires}; domain=.panzitech.com; path=/`;
  } else if (hostname.endsWith(".bujue.art")) {
    document.cookie = `mtoken=; expires=${expires}; domain=.bujue.art; path=/`;
  }
}

export function redirectToLogin() {
  if (window.location.pathname !== "/entrust_product.html") return;
  if (authRedirecting || /\/login(?:Loading)?\.html/.test(window.location.pathname)) return;

  authRedirecting = true;
  clearExpiredToken();
  const targetUrl = `${window.location.pathname}${window.location.search}${window.location.hash}`;
  window.location.replace(`/login.html?redirectUrl=${encodeURIComponent(targetUrl)}`);
}

function handleAuthResponse(response) {
  if (response?.status === 401) redirectToLogin();
  return response;
}

export function post(url, params, headers = {}) {
  const lang_private_close = sessionStorage.getItem('lang_private_close')
  const lang_private = sessionStorage.getItem("lang_private")
  const lang = !lang_private_close&&lang_private || sessionStorage.getItem("lang") || "zh-CN,zh";
  return fetch(url, {
    method: "POST",
    body: JSON.stringify(params),
    credentials: "same-origin",
    headers: {
      "content-type": "application/json",
      "Accept-Language": lang + ";q=0.9",
      ...headers,
    },
  }).then(handleAuthResponse).then((res) => res.json());
}

export function get({ url, skipAcceptLanguage = false }) {
  const headers = {
    "content-type": "application/json",
  };

  if (skipAcceptLanguage) {
    headers["Accept-Language"] = "";
  } else {
    const lang_private_close = sessionStorage.getItem('lang_private_close')
    const lang_private = sessionStorage.getItem("lang_private")
    const lang = !lang_private_close&&lang_private || sessionStorage.getItem("lang") || "zh-CN,zh";
    headers["Accept-Language"] = lang + ";q=0.9";
  }

  return fetch(url, {
    method: "GET",
    headers,
  })
    .then(handleAuthResponse)
    .then((res) => res.json())
    .catch((err) => {
      console.log(err);
    });
}

export function fetchLang(url, params, setLang=null) {
  const lang_private_close = sessionStorage.getItem('lang_private_close')
  const lang_private = sessionStorage.getItem("lang_private")
  const lang = setLang || !lang_private_close&&lang_private || sessionStorage.getItem("lang") || "zh-CN,zh";
  let headers = {
    "Accept-Language": lang + ";q=0.9",
  };
  if (params?.headers) {
    headers = { ...params?.headers, "Accept-Language": lang + ";q=0.9" };
  }
  // 显式带同源 cookie：SketchUp 插件内嵌 Chrome 64，fetch 默认 credentials 是 'omit'(不带 cookie)，
  // 导致同源接口拿不到 mtoken cookie → 302 跳登录。Chrome 68+ 默认即 'same-origin'，对现代 web 是无变化。
  return fetch(url, { credentials: "same-origin", ...params, headers }).then(handleAuthResponse);
}

export function axiosLang(lang){
  const lang_private_close = sessionStorage.getItem('lang_private_close')
  const lang_private = sessionStorage.getItem("lang_private")
  // 显式传入时以调用方解析好的语言为准（用户当前切换到的语言），
  // 否则沿用 sessionStorage 兜底逻辑。
  const requestLang = lang || (!lang_private_close&&lang_private || sessionStorage.getItem("lang") || "zh-CN,zh");
  const instance = axios.create({
    headers: {"Accept-Language": requestLang + ";q=0.9" }
  });
  instance.interceptors.response.use(
    (response) => handleAuthResponse(response),
    (error) => {
      if (error?.response?.status === 401) redirectToLogin();
      return Promise.reject(error);
    }
  );
  return instance;
}
